import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as organizations from '../../organizations'

import type { TypeParams } from './types'

export default ec.associations.create<TypeParams>(function ({
  jobTitleId,
  organization,
}) {
  this.select({
    collection: ec.Name.Predefined.SpaceJobTitle,
    id: jobTitleId,
    update: (updatedEntity, updatedId) => {
      updatedEntity.jobTitleId = TypeAsserter.validateButJustWarn(
        updatedId,
        TypeAsserter.Factory.from(
          TypeChecker.Factory.optional(ents.extra.space.JobTitle.Id.isId),
        ),
      )
    },
  })
  this.select({
    collection: organizations.Name.from(
      organization?.entityId ?? organizations.constants.DEPARTMENT_ENTITY_ID,
    ),
    id: organization?.recordId,
    update: (updatedEntity, updatedId) => {
      updatedEntity ??= {}
      updatedEntity.organization = updatedId
        ? {
            entityId: TypeAsserter.validateButJustWarn(
              organization?.entityId,
              TypeAsserter.assertIsNotNullish,
            ),
            recordId: TypeAsserter.validateButJustWarn(
              updatedId,
              ents.extra.space.Organization.Id.assertIsId,
            ),
          }
        : undefined
    },
  })
})
